import React from "react";
import { Input, InputProps } from "@chakra-ui/react";

interface Props extends InputProps {}
const BotDetectInput: React.FC<Props> = ({
  value,
  onChange,
  onBlur,
  ...props
}) => {
  return (
    <Input
      type="hidden"
      value={value || ""}
      onChange={onChange}
      onBlur={onBlur}
      borderColor={"grey300"}
      {...props}
    />
  );
};

export default BotDetectInput;
